<template>
  <div id="supplements">

    <Datatable
      class="datatable"
      entity="tax_group"
      :globalActions="[{text: 'tax_group.new', method: onCreate}]"
      :rowActions="[{text: 'datatable.edit', method: onRowEdit}, {text: 'datatable.delete', method: onRowDelete}]"
      :onRowClick="onRowEdit">
    </Datatable>
  </div>
</template>

<script>

  import Datatable from "@/components/Datatable.vue";

  export default {

    name: "taxes",

    components: { Datatable },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "tax_groups.title";
      this.$store.state.pageIcon = "";
    },

    methods: {

      onCreate() {
        this.$router.push(this.$router.buildContext("/tax-group"));
      },
      onRowEdit(row) {
        this.$router.push(this.$router.buildContext("/tax-group", {id: row.id}));
      },
      async onRowDelete(row) {
        toast('TODO delete TaxGroup', 'error');
      }
    }
  }

</script>

<style lang="scss" scoped>

  .datatable {
    height: 100%;
  }

</style>
